// extracted by mini-css-extract-plugin
export default {"productdiv":"FactoryCharacteristics__productdiv__-8O7A","addmoreleg":"FactoryCharacteristics__addmoreleg__G0CjT","delete_box":"FactoryCharacteristics__delete_box__V2D36"};